import { type ID, ProjectActions } from '@octopus-do/octopus-project-core'
import type { AppThunk } from '@store/migrationActions/thunkActions/types'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { getId } from '@store/utils'
import { notificationActionCreators } from '@storeOld/reducers/notification'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export const thunkAddColor =
  ({
    hexCode,
    id = getId(),
    title = 'Untitled',
    showInLegend = false,
  }: {
    hexCode: string
    id?: ID
    title?: string
    showInLegend?: boolean
    enableDuplicate?: boolean
  }): AppThunk =>
  (dispatch, getState) => {
    const colors = migrationProjectSelector.getProjectColors(getState())
    const usedHexColor = colors.find((item) => item.hexCode === hexCode)

    if (usedHexColor) {
      const title = `${usedHexColor?.title?.slice(0, 32)}...`

      dispatch(
        notificationActionCreators.setCustomNotification({
          type: 'coral',
          toastContainerId: 'secondary',
          text: `This color already using as ${title}. Please pick another color`,
        })
      )

      return null
    }

    const color = {
      id,
      hexCode,
      title,
      showInLegend,
    }

    dispatch({
      type: 'COMMIT_PROJECT_REQUEST',
      payload: [ProjectActions.colors.add({ items: [color] })],
    })
    sendGtmEvent(GtmTriggerName.COLOR_ADD, 'New color is added to the palette')

    return id
  }

export const thunkDeleteColor =
  (id: ID): AppThunk =>
  async (dispatch, getState) => {
    const nextColor = migrationProjectSelector.getProjectDefaultColorId(
      getState()
    )

    dispatch({
      type: 'COMMIT_PROJECT_REQUEST',
      payload: [ProjectActions.colors.delete({ ids: [id], nextColor })],
    })
  }
